import script from "./PartnerDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerDetails.vue?vue&type=script&setup=true&lang=js"

import "./PartnerDetails.vue?vue&type=style&index=0&id=1ac409fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac409fe"]])

export default __exports__